import page from '../../../components/page';
import {store} from '../../../store/store.js';
import {CommonUtil} from "../../../common/CommonUtil";
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";

export default {
    name: 'ebookcollect',
    data() {
        return {
            bookList: [],
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            isFocusId: 0,
            pageCount: 12,
            pageNo: 1,
          imgPath:imgPath,
        }
    },
    components: {
        page
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
        store.personal._this.activeNav = "我的收藏";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var url = api.ebook.collections.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount).replace('{readerId}', store.func.getUserObj().readerId);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                if (data.resultList != null) {
                    this.bookList = data.resultList;
                    this.countFont()
                }
                this.totalPage = data.totalPage;
            }, null, this);
        },
        toBookInfo(item) {
            this.$router.push({path: '/ebookinfo', query: {id: item.id, hallCode: ''}});
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        /*计算文字内容超出150字省略*/
        countFont() {
            for (let i = 0; i < this.bookList.length; i++) {
                this.bookList[i].bookNameShort = this.bookList[i].bookName;
                if (this.bookList[i].bookName.length > 16) {
                    this.bookList[i].bookNameShort = this.bookList[i].bookName.substr(0, 15) + '...'
                }
            }
        },
        /*
          鼠标悬停效果
          @index 数组下标
          @status true 显示图书信息 false 信息框消失
        * */
        showActive(id, status) {
            if (status) {
                this.isFocusId = id;
            } else {
                this.isFocusId = 0;
            }
        },

    }

}
